export default "__VITE_ASSET__CEJ_ejLF__"